import { useMemo } from 'react';
import { VehiclePartCategoryTreeItem } from '@1po/1po-bff-fe-spec/generated/catalog/category/model/VehiclePartCategoryTreeItem';

export const ROUTINE_VEHICLE_MAINTENANCE_GROUP_NODE_ID = 'N-21347';
export const isMaintenanceNodeId = (nodeId: string): boolean => nodeId === ROUTINE_VEHICLE_MAINTENANCE_GROUP_NODE_ID;

export function findNodeByLabel(
  element: VehiclePartCategoryTreeItem | undefined,
  label: string,
): VehiclePartCategoryTreeItem | undefined {
  if (!element) return undefined;
  if (element.label.toLowerCase() === label.toLowerCase()) {
    return element;
  } else if (element.items) {
    let result = undefined;
    for (let i = 0; result === undefined && i < element.items.length; i++) {
      result = findNodeByLabel(element.items[i], label);
    }
    return result ? { ...element, items: [result] } : undefined;
  }
  return undefined;
}

export interface RvmL3Item {
  label: string;
  nodeId: string;
  path: string;
  operationIds: string[];
}

export interface RvmL2Section {
  label: string;
  nodeId: string;
  operationIds: string[];
  l3Items: RvmL3Item[];
}

export function useRvmL2Sections(
  rvmNode: VehiclePartCategoryTreeItem | undefined,
  otherL1Items: VehiclePartCategoryTreeItem[],
): RvmL2Section[] {
  return useMemo(() => {
    if (!rvmNode) return [];
    return rvmNode.items.map((l2Item) => ({
      label: l2Item.label,
      nodeId: l2Item.nodeId,
      operationIds: l2Item.operationIds,
      l3Items: l2Item.items
        .map((l3Item) => {
          for (const el of otherL1Items) {
            const result = findNodeByLabel(el, l3Item.label);
            if (result) {
              const lvl2Item = result.items.length > 0 ? result.items[0] : undefined;
              const lvl3Item = lvl2Item && lvl2Item.items.length > 0 ? lvl2Item.items[0] : undefined;
              if (
                result.nodeId &&
                lvl2Item?.nodeId &&
                lvl3Item?.nodeId &&
                (lvl3Item?.plateIds?.length > 0 || lvl3Item?.containsMarketingReferences)
              ) {
                return {
                  label: l3Item.label,
                  nodeId: l3Item.nodeId,
                  path: `${result.nodeId}/${lvl2Item.nodeId}/${lvl3Item.nodeId}`,
                  operationIds: l3Item.operationIds,
                };
              }
            }
          }
          return undefined;
        })
        .filter((item): item is RvmL3Item => item !== undefined),
    }));
  }, [rvmNode, otherL1Items]);
}
